import type { AttentionStatusType } from '../../evaluation/AttentionStatus';

const orderedList = [
  'ATTENTION_REQUIRED',
  'ATTENTION_SUGGESTED',
  'NO_ATTENTION_REQUIRED',
  'NOT_EVALUATED'
];
export const selectHigherAttentionStatus = (
  status1: AttentionStatusType,
  status2: AttentionStatusType
) => {
  return orderedList.indexOf(status1) > orderedList.indexOf(status2)
    ? status2
    : status1;
};
